import { TreeItem, TreeItemIndex } from 'react-complex-tree'

import type { I18nShape } from '@tribeplatform/react-components/i18n'

import { NoCollectionTreeItem } from '../components/NoCollectionTreeItem.js'
import { SimpleTreeItemData } from '../types.js'

export const NO_COLLECTION_INDEX = 'no-collection'

export function createNoCollectionTreeItem(
  { $t }: I18nShape,
  {
    children,
  }: {
    children: TreeItemIndex[]
  },
): TreeItem<SimpleTreeItemData> {
  return {
    index: NO_COLLECTION_INDEX,
    isFolder: true,
    data: {
      title: $t({
        id: 'Admin.SiteTree.NoCollection',
        defaultMessage: 'No collection',
      }) as string,
      type: 'simple',
      render: NoCollectionTreeItem,
    },
    children,
  }
}
